
import React from 'react';

const Terms = () => {
  return (
    <div className="container mx-auto px-4 py-12">
      <h1 className="text-4xl font-bold text-bitcoin-accent mb-6">Bitcoin Mining Career Simulator - Terms of Use</h1>
      <p className="text-white/60 mb-8">Effective Date: May 1, 2025</p>
      
      <div className="prose prose-invert max-w-none">
        <h2 className="text-2xl font-semibold text-web3-green mb-4">1. Introduction and Acceptance of Terms</h2>
        <p className="mb-4">
          Welcome! The Bitcoin Mining Career Simulator is developed and operated by The Blockchain Academy Inc., 
          a leading provider of blockchain and cryptocurrency education.
        </p>
        <p className="mb-4">
          This simulator is designed as an educational companion tool to help individuals explore potential career 
          paths in the Bitcoin mining industry. By accessing or using the simulator, you agree to these Terms of Use. 
          If you do not agree, please discontinue use immediately.
        </p>

        <h2 className="text-2xl font-semibold text-web3-green mb-4">2. Educational and Entertainment Purposes Only</h2>
        <p className="mb-4">
          The simulator is intended solely for educational and entertainment purposes. It provides:
        </p>
        <ul className="list-disc pl-6 mb-4">
          <li>Simulated career paths and scenarios within the Bitcoin mining sector</li>
          <li>Educational content related to blockchain and cryptocurrency industries</li>
          <li>Interactive experiences that encourage critical thinking and exploration</li>
        </ul>
        <p className="mb-4">
          The simulator is not a professional certification, financial advice platform, or employment service.
          Outcomes in the simulator are fictionalized and illustrative, designed to enhance learning, not to predict real-world results.
        </p>

        <h2 className="text-2xl font-semibold text-web3-green mb-4">3. Your Responsibilities</h2>
        <p className="mb-4">
          When using the simulator, you agree to:
        </p>
        <ul className="list-disc pl-6 mb-4">
          <li>Provide honest and accurate information when requested</li>
          <li>Keep your account information secure and confidential</li>
          <li>Follow all applicable laws and regulations</li>
          <li>Respect the integrity of the platform—no hacking, exploiting, or unauthorized use</li>
        </ul>
        <p className="mb-4">
          Misuse of the simulator may result in suspension or termination of access.
        </p>

        <h2 className="text-2xl font-semibold text-web3-green mb-4">4. Intellectual Property</h2>
        <p className="mb-4">
          All content within the Bitcoin Mining Career Simulator—including but not limited to text, graphics, 
          software, educational modules, and career path simulations—is owned by The Blockchain Academy Inc. 
          and protected under copyright, trademark, and other intellectual property laws.
        </p>
        <p className="mb-4">
          You may not copy, reproduce, modify, distribute, or create derivative works from any part of the 
          simulator without express written consent.
        </p>

        <h2 className="text-2xl font-semibold text-web3-green mb-4">5. Limitations of Liability</h2>
        <p className="mb-4">
          The simulator is provided "as is" without warranties of any kind, either express or implied. Specifically:
        </p>
        <ul className="list-disc pl-6 mb-4">
          <li>We are not responsible for career outcomes or decisions based on use of the simulator</li>
          <li>We do not guarantee uninterrupted access or error-free operation</li>
          <li>We are not liable for any direct, indirect, incidental, or consequential damages, including loss of data, revenue, or opportunities</li>
          <li>All scenarios are for learning and exploration purposes only and should not be interpreted as real-world forecasts or advice</li>
        </ul>
        <p className="mb-4">
          Use the simulator as a tool for inspiration and education, not a roadmap for guaranteed success.
        </p>

        <h2 className="text-2xl font-semibold text-web3-green mb-4">6. Modifications to Terms</h2>
        <p className="mb-4">
          We may update these Terms of Use from time to time to reflect changes in the simulator, industry standards, 
          or legal requirements. When updates are made, we will post the revised Terms on this page with an updated 
          effective date.
        </p>
        <p className="mb-4">
          Continued use of the simulator after changes are posted constitutes acceptance of the updated Terms. 
          We encourage users to review the Terms periodically.
        </p>
      </div>
    </div>
  );
};

export default Terms;
